import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import RfiItem from "./RfiItem";
import useAPIError from "../../APIError";
import { ApplicationDataAPI } from '../../API/ApplicationDataAPI';

export default function RfiList(props) {
	const { rfiList } = props;
	const [pendingList, setPendingList] = useState([]);
	const [documents, setDocuments] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const [closedList, setClosedList] = useState([]);
	const { addError } = useAPIError();

	useEffect(() => {
		setPendingList(rfiList?.pending ? rfiList.pending : []);
		setClosedList(rfiList?.closed ? rfiList.closed : []);
	}, [rfiList]);

	useEffect(() => {
		(async () => {
			if (props.app) {
				try {
					await ApplicationDataAPI.fetchApplicationDocumentsById(props.app.id, "ALL", props.app.locked_by_email)
						.then((response) =>
							setDocuments(response)
						);
				} catch (error) {
					addError(error);
				} finally {
					setRefresh(false);
				}
			}
		})();
	}, [rfiList, refresh, addError]);

	const onRfiResolved = (rfiData) => {
		let tempCloseds = closedList;
		let tempPendings = [];

		pendingList.forEach((rfi) => {
			if (rfi.id !== rfiData.id) {
				tempPendings.push(rfi);
			}
		});

		setPendingList(tempPendings);
		tempCloseds.push(rfiData);
		setClosedList(tempCloseds);
	};

	return (
		<Table>
			<TableBody>
				<TableRow>
					<TableCell>
						{pendingList.map((rfi, index) => (
							<RfiItem
								key={index}
								rfi={rfi}
								onRfiSaved={props.onRfiSaved}
								app={props.app}
								documents={documents}
								setRefresh={setRefresh}
							/>
						))}

						{closedList.map((rfi, index) => (
							<RfiItem
								key={index}
								rfi={rfi}
								onRfiSaved={onRfiResolved}
								app={props.app}
								documents={documents}
								setRefresh={setRefresh}
							/>
						))}
					</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	);
}
